/* @generated */

// src/assets/ui-icon/line/pdf.tsx
import * as React from "react";
var PdfLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m15.47 4.659 1.37 1.371c.42.422.657.994.659 1.59V9.5H16V8h-2.5V5.5h-7v13H16V17h1.5v3H5V4h8.879a2.237 2.237 0 0 1 1.59.659Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M8.584 13.893h.17c1.084 0 1.722-.346 1.722-1.48 0-1.05-.55-1.413-1.628-1.413H7.5v4.208h1.084v-1.315Zm.242-.863h-.242v-1.194h.253c.374 0 .56.127.56.594 0 .44-.22.6-.571.6ZM11.5 11v4.208h1.178c1.237 0 1.806-.76 1.806-2.057 0-1.49-.57-2.15-1.801-2.15H11.5Zm1.145 3.394h-.082v-2.59h.082c.412 0 .705.296.705 1.336 0 .957-.287 1.254-.705 1.254Zm3.933.814V13.65h1.54v-.836h-1.54v-.979h1.584V11H15.5v4.208h1.078Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PdfLine
};
